// Начертание прогнозного хода судна. Вынесено из MapCanvas ради проверяемости:
// здесь не украшение, а правило честности — сплошную линию получает ТОЛЬКО
// судно, о котором известно, что оно на переходе. Манёвр и незнание режима
// рисуются одинаково мягко: разметку операций кладёт часовой таймер, и у
// свежего фикса отрезка может ещё не быть.
//
// Цвет линии берётся у САМОГО СУДНА (`vessel-fresh`), а не заводит свой ключ:
// это его собственный будущий путь, и разъехаться с маркером он не вправе.
import type { ExpressionSpecification } from 'maplibre-gl'

import { mapColorOf } from '../brand/mapColors'

export type ForecastConfidence = 'firm' | 'soft'

/** Толщина линии, px. Тоньше трека судна: прогноз — не измерение. */
export const FORECAST_WIDTH = 2.0

/** Пунктир мягкой линии, в толщинах линии. */
export const FORECAST_DASHARRAY = [2, 2]

const OPACITY: Record<ForecastConfidence, number> = { firm: 0.9, soft: 0.55 }

/** Заливка линии под данное доверие. */
export function forecastLinePaint(confidence: ForecastConfidence): Record<string, unknown> {
  const paint: Record<string, unknown> = {
    'line-color': mapColorOf('vessel-fresh'),
    'line-width': FORECAST_WIDTH,
    'line-opacity': OPACITY[confidence],
  }
  if (confidence === 'soft') paint['line-dasharray'] = FORECAST_DASHARRAY
  return paint
}

/** Фильтр слоя: своя половина коллекции, чтобы два начертания не легли одно
 *  поверх другого. */
export function forecastConfidenceFilter(
  confidence: ForecastConfidence,
): ExpressionSpecification {
  return ['==', ['get', 'confidence'], confidence] as ExpressionSpecification
}

/** Заливка отметок часов. Цвет — тот же, что у линии: это один и тот же путь,
 *  и разъехаться им нельзя. Белая обводка — приём читаемости поверх чужого
 *  растра, а не айдентика. */
export function forecastMarkPaint(): Record<string, unknown> {
  return {
    'circle-radius': 3,
    'circle-color': mapColorOf('vessel-fresh'),
    'circle-opacity': 0.9,
    'circle-stroke-width': 1,
    'circle-stroke-color': '#ffffff',
  }
}
